<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'NUEVA ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre Sucursal
                        input.form-control.form-control-sm(v-model="parameter.OfficenName", @keypress.enter="sendInfo()") 
                .form-row
                    .col-md-12.col-sm-12
                        label Direccion
                        input.form-control.form-control-sm(v-model="parameter.Adress")
                .form-row
                    .col-md-6.col-sm-12
                        label Nombre Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactName")
                    .col-md-6.col-sm-12
                        label Telefono Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactPhone")
                .form-row 
                    .col-md-6.col-sm-12
                        label Email Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactEmail")
                    .col-md-6.col-sm-12
                        label Cargo Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactPosition")
        div(slot='footer')
            button.btn.btn-primary(@click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue"
import toolValidate from '../../../tools/validate.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.OfficenName=='' || this.parameter.OfficenName==null ){
                    this.$msgbox.show("Ingrese Nombre de Sucursal","Alerta")
                    return false
                } 
                else if(this.parameter.Adress=='' || this.parameter.Adress==null ){
                    this.$msgbox.show("Ingrese Direccion","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>